import { Dispatch } from "redux";
import {AuthGuestActionTypes, AuthGuestCreateAction} from "../../types/auth/authGuest";
import axios from "axios";

interface ErrorResponse {
    code: string | number;
    message: string;
    details?: any[];
}

export const authGuest = () => {
    return async (dispatch: Dispatch<AuthGuestCreateAction>) => {
        try {
            dispatch({ type: AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA });

            const response = await axios({
                method: 'post',
                url: `/api/guest`,
                withCredentials: false,
            });

            dispatch({
                type: AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA_SUCCESS,
                payload: response.data ?? response.status,
            });

        } catch (error: any) {
            let errorPayload: ErrorResponse = {
                code: -1,
                message: 'Unknown error occurred',
                details: [],
            };

            if (axios.isAxiosError(error)) {
                const responseData = error.response?.data;

                if (responseData?.error) {
                    errorPayload = {
                        code: responseData.error.code,
                        message: responseData.error.message,
                        details: responseData.error.details || [],
                    };
                } else if (typeof responseData === 'string') {
                    errorPayload = {
                        code: error.response?.status || -1,
                        message: responseData,
                        details: [],
                    };
                } else {
                    errorPayload = {
                        code: error.response?.status || -1,
                        message: error.message || 'Unknown error occurred',
                        details: [],
                    };
                }
            }

            dispatch({
                type: AuthGuestActionTypes.FETCH_AUTH_GUEST_DATA_ERROR,
                payload: errorPayload,
            });
        }
    };
};

export const clearAuthGuestData = () => {
    return (dispatch: Dispatch<AuthGuestCreateAction>) => {
        dispatch({
            type: AuthGuestActionTypes.CLEAR_AUTH_GUEST_DATA,
            payload: []
        });
    };
};